export default __webpack_public_path__ + "static/media/2D1A7171.5f90a81e.jpg";